<template>
    <div class="xl:grid xl:grid-cols-3 md:grid md:grid-cols-2 lg:mx-auto">
        <runner v-for="runner in runners" :selections="selections" :runner="runner" :meeting="meeting" :bets="bets" :showPercentage="showPercentage" @runnerSelected="$emit('updateSelected', runner)" @updateRunner="$emit('updateRunner', runner)"/>
    </div>
</template>

<script>
    export default {

        props: {
            meeting: {
                type: Object,
                default: {}
            },
            bets: {
                type: Array,
                default: []
            },
            runners: {
                type: Object,
                default: {}
            },
            selections: {
                type: Object,
                default: {}
            },
            showPercentage: {
                type: Object,
                default: {}
            },
        },

        emits: ['updateSelected', 'updateRunner', 'scrollToElement'],
    }
</script>
